import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  TabText,
} from '@tq/ui-components';

import { PageHeading } from 'components';
import {
  IncomingConsultationsMonitorTable,
  MonitorTable,
  ExceptionLogsMonitorTable,
} from './components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

export const Monitor: React.FC = () => {
  const { t } = useTranslation('traffic_monitor');
  const tabLabels = [
    t('inbound_calls', 'Inbound calls'),
    t('outbound_calls', 'Outbound calls'),
    t('incoming_consultations', 'Incoming consultations'),
    t('exceptions', 'Exceptions'),
  ];

  const tabPanelStyle = {
    border: { base: 'none', lg: `1px solid ${COLOURS.gray[400]}` },
    px: { base: 0, lg: 5 },
    py: { base: 0, lg: 4 },
  };

  return (
    <>
      <Container px={{ base: 0, lg: 4, xl: 0 }}>
        <PageHeading heading={t('traffic-monitor', 'Traffic monitor')} />
      </Container>
      <Container px={{ base: 0, lg: 4, xl: 0 }}>
        <Tabs variant='enclosed' p={0} mt={8} mb={12} mx={{ base: -5, lg: 0 }} isManual={true}>
          <TabList color={COLOURS.blue[600]} sx={{ '.tqc-badge': { ml: 3 } }}>
            {tabLabels.map((tabLabel) => (
              <Tab key={tabLabel}>
                <TabText fontSize={18}>{tabLabel}</TabText>
              </Tab>
            ))}
          </TabList>
          <TabPanels
            my={{ base: 5, lg: 0 }}
            border={{ base: 0, md: 'unset' }}
            p={{ base: 0, md: 'unset' }}
            minH={{ base: undefined, md: 400 }}
            color={COLOURS.black}
            overflow={{ base: 'scroll', lg: 'auto' }}
          >
            <TabPanel {...tabPanelStyle}>
              <MonitorTable callDirection='Inbound' />
            </TabPanel>
            <TabPanel {...tabPanelStyle}>
              <MonitorTable callDirection='Outbound' />
            </TabPanel>
            <TabPanel {...tabPanelStyle}>
              <IncomingConsultationsMonitorTable />
            </TabPanel>
            <TabPanel {...tabPanelStyle}>
              <ExceptionLogsMonitorTable />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Container>
    </>
  );
};
